'use client';

import { useState } from 'react';
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Skeleton } from '@mui/material';

interface CryptoFinanceSidebarSkeletonProps {
  variant?: 'sidebar' | 'chips';
}

export const CryptoFinanceSidebarSkeleton = ({
  variant = 'sidebar',
}: CryptoFinanceSidebarSkeletonProps) => {
  const [width] = useState(() => `${Math.floor(Math.random() * 40) + 30}%`);
  if (variant === 'chips') {
    return (
      <Box
        sx={{
          display: { xs: 'flex', md: 'none' },
          gap: 1,
          overflowX: 'auto',
          pb: 1,
          mx: -2,
          px: 2,
          mb: 0.5,
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        {[1, 2, 3, 4, 5].map((i) => (
          <Skeleton
            key={i}
            variant="rounded"
            width={56}
            height={40}
            sx={{ borderRadius: 1, flexShrink: 0 }}
          />
        ))}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: 240,
        flexShrink: 0,
        display: { xs: 'none', md: 'block' },
        position: 'sticky',
        top: 80,
        maxHeight: 'calc(100vh - 100px)',
        overflow: 'hidden',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '16px',
        p: 2,
        bgcolor: 'background.paper',
      }}
    >
      <Box sx={{ px: 2, mb: 2 }}>
        <Skeleton variant="text" width={80} height={32} sx={{ borderRadius: 1 }} />
      </Box>
      <List sx={{ p: 0 }}>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <Box key={i}>
            <ListItemButton
              disabled
              sx={{
                borderRadius: 2,
                mb: 0.5,
                py: 1.2,
                px: 2,
                opacity: 0.7,
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <Skeleton variant="circular" width={20} height={20} animation="wave" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Skeleton
                    variant="text"
                    width={width}
                    animation="wave"
                    sx={{ borderRadius: 1 }}
                  />
                }
              />
              <Skeleton
                variant="text"
                width={20}
                height={20}
                animation="wave"
                sx={{ ml: 1, fontSize: '1rem' }}
              />
            </ListItemButton>
            {(i === 4 || i === 8) && (
              <Skeleton variant="rectangular" height={1} sx={{ my: 2, mx: 2, opacity: 0.5 }} />
            )}
          </Box>
        ))}
      </List>
    </Box>
  );
};

export default CryptoFinanceSidebarSkeleton;
